import classNames from 'classnames';
import { useContext } from 'react';
import { Outlet } from 'react-router-dom';

import PageContext from '@/Providers/PageContextProvider/PageContext';
import LogtoSignature from '@/shared/components/LogtoSignature';
import { layoutClassNames } from '@/utils/consts';

import CustomContent from '../AppLayout/CustomContent';

import defaultLightLogo from './assets/aura-full-light.svg';
import defaultBackground from './assets/auth-bg.jpg';
import styles from './index.module.scss';

const SplitLayout = () => {
  const { experienceSettings, theme } = useContext(PageContext);
  const hideLogtoBranding = experienceSettings?.hideLogtoBranding === true;
  const { branding } = experienceSettings ?? {};

  // Brand-panel content is configurable via branding (tenant default, org override),
  // with bundled defaults when a field is empty.
  const background = branding?.backgroundImageUrl ?? defaultBackground;
  const title = branding?.splitHeadline;
  const subtitle = branding?.splitSubtitle;
  // Prefer the configured light logo for the dark image side; fall back to the bundled one.
  const panelLogo = branding?.darkLogoUrl ?? defaultLightLogo;

  return (
    <div className={styles.viewBox}>
      <div className={classNames(styles.split, layoutClassNames.pageContainer)}>
        <aside className={styles.brandPanel} style={{ backgroundImage: `url(${background})` }}>
          <div className={styles.overlay} />
          <div className={styles.panelTop}>
            {/* Decorative: the brand is conveyed visually; the form carries the accessible content. */}
            <img className={styles.panelLogo} src={panelLogo} alt="" />
          </div>
          {(title ?? subtitle) && (
            <div className={styles.panelBottom}>
              {title && <h2 className={styles.panelTitle}>{title}</h2>}
              {subtitle && <p className={styles.panelSubtitle}>{subtitle}</p>}
              <div className={styles.panelAccent} />
            </div>
          )}
        </aside>
        <div className={styles.formPanel}>
          <main className={classNames(styles.main, layoutClassNames.mainContent)}>
            <CustomContent className={layoutClassNames.customContent} />
            <Outlet />
            {!hideLogtoBranding && (
              <LogtoSignature
                className={classNames(styles.signature, layoutClassNames.signature)}
                theme={theme}
              />
            )}
          </main>
        </div>
      </div>
    </div>
  );
};

export default SplitLayout;
